<template>
  <div class="questionnaire-content">
    <Icon
      class="questionnaire__icon-back"
      icon="ui-arrow-left"
      @click="setStep('Register')"
    />
    <div class="questionnaire-content__block">
      <p class="questionnaire__title -min-margin-">
        Отлично, последний шаг!
      </p>
      <p class="questionnaire__description">
        Подключи бота и не упускай крутых возможностей!
      </p>
    </div>
    <div class="questionnaire-content__block">
      <p class="questionnaire-content__title">
        Ссылка на бота
      </p>
    </div>
    <div class="questionnaire-content__block">
      <a
        class="questionnaire-button-telegram"
        :href="tgRedirectLink"
        target="_blank"
        @click="active = true"
      >
        <Icon icon="telegram" /><span>Перейти</span>
      </a>
    </div>
    <div class="questionnaire-content__block">
      <CopyCode
        title="Код"
        :text="code"
        :loading="!code"
      />
    </div>
    <div class="questionnaire-content__block -margin-s-">
      <UiButton
        :disabled="!active"
        to="/courses/folder/list"
      >
        Продолжить
      </UiButton>
    </div>
  </div>
</template>

<script>
import config from '@/config';
import { mapState } from 'vuex';
import CopyCode from '../components/CopyCode';

export default {
  components: {
    CopyCode
  },
  data: () => ({
    code: '',
    active: false,
    interval: 3000,
    timer: null,
    isTimer: false,
    tgRedirectLink: config.APP_DOMAIN + '/bot/link'
  }),
  computed: {
    ...mapState('questionnaire', {
      history: s => s.data.history
    })
  },
  mounted() {
    this.getCode();
    this.isTimer = true;
    this.startSendQuery();
  },
  destroyed() {
    this.stopSendQuery();
  },
  methods: {
    async getCode() {
      const res = await this.$store.dispatch('questionnaire/getTelegramCode');
      if (res.code) {
        this.code = res.code;
        // this.active = res.active
      }
    },
    startSendQuery() {
      this.timer = setTimeout(async () => {
        await this.getCode();

        if (!this.active && this.isTimer) {
          this.timer = this.startSendQuery();
        }
      }, this.interval);
    },
    stopSendQuery() {
      this.isTimer = false;
      clearTimeout(this.timer);
    },
    comeBack() {
      this.$store.dispatch('questionnaire/comeBackHistory');
    },
    setStep(step) {
      this.$emit('setStep', step);
    }
  }
};
</script>

<style scoped>
.questionnaire__icon-back {
  display: unset;
}
</style>
